import React, { useEffect, useState } from 'react'
import "./page.css"
import svgSodxs from "../icon/sodexs.svg"

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50) 
    }

    window.addEventListener("scroll", handleScroll)

    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  return (
    <section className={`header-section ${isScrolled ? "scroll" : ""}`}>
      <div className='div-header'>
        <img src={svgSodxs} alt='sodexs logo'/>
      </div>
    </section>
  )
}

export default Header